import { Container, Row } from "reactstrap";
import RegisterSimpleContainer from "../../Componant/Authentication/RegisterSimple";

const RegisterSimple = () => {
  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <RegisterSimpleContainer />
      </Row>
    </Container>
  );
};

export default RegisterSimple;
